<template>
    <div :id="character.id"><img :id="character.id" :src="character.asset.src" />{{ character.id }}</div>
</template>

<style scoped>
img {
    width: 50px;
    height: 50px;
}
</style>

<script lang="ts">
export default {
    props: {
        character: {
            type: Object,
            default: function() {
                return {
                    id: 'default',
                    asset: { kind: 'image', src: '/static/assets/marc.png' },
                };
            },
        },
    },
};
</script>
